<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <div class="mb-4">
            <h1 class="card-title mb-1">Raw Material Inventory</h1>
            <span class="sub-text">Manage categories, materials, and warehouse inventory.</span>
          </div>

          <div class="mb-4">
            <ul class="nav nav-pills mb-4" role="tablist">
              @for (tab of tabs; track tab) {
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    [ngClass]="{ active: selectedTab === tab.value }"
                    (click)="selectTab(tab.value)">
                    <i [class]="tab.icon"></i>
                    <span class="ms-2">{{ tab.label }}</span>
                  </button>
                </li>
              }
            </ul>
          </div>

          <ng-container [ngSwitch]="selectedTab">
            <ng-container *ngSwitchCase="RawMaterialTab.CATEGORIES">
              <app-raw-material-categories />
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.MATERIAL">
              <app-raw-material [units]="units" />
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.ENTRIES">
              <app-raw-material-entry [wareHouses]="wareHouses" />
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.SUPPLIERS">
              <app-suppliers></app-suppliers>
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.PURCHASED_ORDER">
              <app-purchased-order [wareHouses]="wareHouses"></app-purchased-order>
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.INVENTORY">
              <app-inventory [wareHouses]="wareHouses" />
            </ng-container>

            <ng-container *ngSwitchCase="RawMaterialTab.STOCK_ADJUSTMENTS">
              <app-stock-adjustments [wareHouses]="wareHouses" />
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
